export default {"src":"/_next/static/media/lawfinder-logo.405b99c5.svg","height":258,"width":738,"blurWidth":0,"blurHeight":0};